"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.gql = void 0;
/**
 * Custom GQL template literal tag for syntax highlighting and auto-complete of GQL operations in IDEs.
 */ var gql = exports.gql = String.raw; //# sourceMappingURL=gql.js.map
